import React, { FunctionComponent, useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import RefundIcon from './icons/RefundIcon';
import summaryReservationStyles from './summaryReservationStyles';
import usePriceFormatter from '../../../../../../gqlCommon/hooks/prices/usePriceFormatter';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import { RefundableState } from '../../../../../enum/RefundableState';
import { refundableStateTranslationMap } from '../../../../../constants/refundableStateTranslationMap';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

const SummaryReservation: FunctionComponent = () => {
  const {
    platformConfig: {
      priceDisplay: { primary },
      showIndicativeDeliveryTimeframe,
    },
  } = usePlatformConfig();
  const { selectedCar } = useCustomizeCarContext();
  const styles = summaryReservationStyles();
  const { price, refundableState } = selectedCar.reservationFee || {};
  const refundableAmount = price?.find(price => price.currency === primary.currency);
  const { deliveryTimeFrameLabel } = selectedCar.deliveryTimeFrame || {};

  const refundableLabel = useMemo(() => {
    if (refundableAmount && refundableState && !!refundableStateTranslationMap?.[refundableState as RefundableState]) {
      return refundableStateTranslationMap[refundableState as RefundableState];
    }
    return 'trans__configurator__customise_page_summary_section__reservation_fee_non_refundable';
  }, [refundableAmount, refundableState]);

  const { format } = usePriceFormatter({
    currency: primary.currency,
    decimals: primary.decimalScale,
    useCurrencySign: true,
  });

  if (!refundableAmount || !refundableState) {
    return null;
  }

  return (
    <Box className={styles.container} data-test="summary:reservation:container">
      <Box className={styles.iconContainer} data-test="summary:reservation:icon">
        <RefundIcon className={styles.icon} />
      </Box>
      <Box className={styles.labelContainer}>
        <Typography component="p" variant="body1" className={styles.title} data-test="summary:refundableAmount:title">
          <Translation id="trans__configurator__customise_page_summary_section__reservation_fee_title" />
        </Typography>
        <Typography component="span" variant="body2" data-test="summary:refundableAmount:label">
          <Translation id={refundableLabel} values={{ reservation_fee: format(refundableAmount.amount) }} />
        </Typography>

        {deliveryTimeFrameLabel && showIndicativeDeliveryTimeframe && (
          <Typography component="span" variant="body2" data-test="summary:deliveryTimeFrame:label">
            {' '}
            <Translation
              id="trans__configurator__customise_page__delivery_time_frame"
              values={{ value: deliveryTimeFrameLabel }}
            />
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SummaryReservation;
